/**
 * pr-product1-mobile.js — PrettyRobes Satin Robe Product Page
 * Mobile gallery enhancements. Loaded by pr-main-product1.liquid via asset_url.
 *
 * Two behaviours, both mobile-only and fully self-contained — this file does
 * NOT re-bind anything the section's inline <script> already owns (colour swap,
 * price, variant, ATC, accordion), so it can run safely alongside it:
 *
 *   1. Edge scroll arrows — chevrons pinned to the gallery's left/right edges
 *      that hint the image strip is swipeable and tap through slides. The prev
 *      arrow hides at the start, the next arrow at the end, both when there's
 *      one image. CSS (pr-product1.css) hides them entirely on desktop.
 *
 *   2. Colour-tap scroll-up — when a colour is picked, the viewport jumps back
 *      up to the gallery so the customer sees the swapped image without
 *      scrolling up. No-op on desktop, where the gallery sits beside the options.
 *
 * Depends only on DOM ids present in the section: #pr-gallery, #pr-scroll-prev,
 * #pr-scroll-next, #pr-color-grid, #pr-color-chart-grid.
 */
(function(){
  'use strict';

  // Idempotency guard — the theme editor can inject this script more than once.
  if (window.__prMobileGalleryInit) return;
  window.__prMobileGalleryInit = true;

  var MOBILE = '(max-width: 768px)';

  function isMobile(){
    return window.matchMedia ? window.matchMedia(MOBILE).matches : (window.innerWidth <= 768);
  }
  function getGallery(){ return document.getElementById('pr-gallery'); }

  /* ── 1. Edge scroll arrows ─────────────────────────────────────── */
  function updateArrowState(){
    var g = getGallery();
    var prev = document.getElementById('pr-scroll-prev');
    var next = document.getElementById('pr-scroll-next');
    if(!g || (!prev && !next)) return;
    var max = g.scrollWidth - g.clientWidth;
    var x = g.scrollLeft;
    var single = max <= 4;                 // one slide — nothing to scroll
    if(prev) prev.classList.toggle('is-hidden', single || x <= 4);
    if(next) next.classList.toggle('is-hidden', single || x >= max - 4);
  }

  // Re-attach the scroll listener whenever the gallery element is (re)found.
  // The inline script replaces the gallery's CHILDREN on a colour swap but
  // keeps the #pr-gallery element itself, so this binds at most once per element.
  function bindGalleryScroll(){
    var g = getGallery();
    if(!g || g.dataset.prArrowScroll === 'true') return;
    g.dataset.prArrowScroll = 'true';
    g.addEventListener('scroll', function(){
      if(g._prArrowRaf) return;
      g._prArrowRaf = requestAnimationFrame(function(){
        g._prArrowRaf = null;
        updateArrowState();
      });
    }, { passive: true });
  }

  /* ── 2. Colour-tap scroll-up (mobile) ──────────────────────────── */
  function scrollGalleryIntoViewMobile(){
    var g = getGallery();
    if(!g || !isMobile()) return;
    var header = document.querySelector('.shopify-section-header, .section-header, sticky-header, header');
    var off = header ? header.getBoundingClientRect().height : 0;
    var top = g.getBoundingClientRect().top + window.pageYOffset - off - 8;
    window.scrollTo({ top: top < 0 ? 0 : top, behavior: 'smooth' });
  }

  /* ── Delegated clicks (survive gallery re-render & section reloads) ── */
  document.addEventListener('click', function(e){
    if(!e.target.closest) return;
    var g = getGallery();

    if(e.target.closest('#pr-scroll-prev')){
      if(g) g.scrollBy({ left: -g.clientWidth, behavior: 'smooth' });
      return;
    }
    if(e.target.closest('#pr-scroll-next')){
      if(g) g.scrollBy({ left: g.clientWidth, behavior: 'smooth' });
      return;
    }

    // Colour pick — from the main swatch grid or the colour-chart modal.
    var colorOpt = e.target.closest('#pr-color-grid .pr-color-opt')
                || e.target.closest('#pr-color-chart-grid .pr-color-chart-item');
    if(colorOpt){
      scrollGalleryIntoViewMobile();
      // The inline script re-renders the gallery ~180–300ms after the click;
      // refresh the arrows once the new slides are in place.
      setTimeout(updateArrowState, 360);
    }
  });

  function init(){
    bindGalleryScroll();
    updateArrowState();
  }

  if(document.readyState === 'loading'){
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
  window.addEventListener('resize', updateArrowState);
  document.addEventListener('shopify:section:load', init);
})();
